import { auth } from '../firebase';

// Inactivity time in milliseconds (10 minutes)
const INACTIVITY_LIMIT = 10 * 60 * 1000;

// Update last activity timestamp on user interaction
function updateActivity() {
  localStorage.setItem('lastActivity', Date.now().toString());
}

// List of events that indicate activity
const activityEvents = [
  'mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'
];

// Attach event listeners for activity
export function startInactivityWatcher() {
  activityEvents.forEach(event => {
    window.addEventListener(event, updateActivity);
  });

  // Initial set
  updateActivity();

  // Check inactivity every 10 minutes
  setInterval(async () => {
    const lastActivity = Number(localStorage.getItem('lastActivity')) || Date.now();
    const now = Date.now();
    if (now - lastActivity > INACTIVITY_LIMIT) {
      // Log out user via Firebase Auth
      if (auth.currentUser) {
        await auth.signOut();
        // You can redirect to login page if needed:
        window.location.href = '/';
      }
    }
  }, 10 * 60 * 1000);
}
